import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PresentToAllIcon(props: IconProps) {
    return <Icon {...props} iconKey={"present_to_all"}/>
}
